export default __webpack_public_path__ + "static/media/pokemon_landing_img.046f8996.png";